<template>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <div class="row">
            <div class="col-md-12">
                <ValidationProvider rules="required" name="Nama" v-slot="{ errors }"
                    :persist="true">
                    <div class="form-group">
                        <label for="">Nama Satuan <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }"
                            v-model="model.name">
                        <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                </ValidationProvider>
            </div>
        </div>

        <hr>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal">Batal</button>
            <button type="button" :disabled="invalid" @click="save()" class="btn btn-primary">
                {{ saving ? 'Menyimpan...' : 'Simpan' }}
            </button>
        </div>
    </ValidationObserver>

</template>

<script>
export default {
    name: 'FormRiwayat',
    data() {
        return {
            saving: false,
            model: {
                name: '',
                id: null,
            },
            mode: 'add',
            errorValidations: {
                name: '',
            },
        }
    },
    methods: {
        resetModel() {
            this.$refs.observer.reset()
            this.model = { name: '', id: null }
            this.mode = 'add'
        },
        editMode(item) {
            this.$refs.observer.reset()
            this.mode = 'edit'
            this.model.name = item.name
            this.model.id = item.id
        },
        save() {
            let _ = this
            _.saving = true
            const payload = { ..._.model };
            const url = _.mode == 'add' ? "/material-units" : "/material-units/" + _.model.id
            const method = _.mode == 'add' ? "post" : "put"
            _.axios({
                method: method,
                url: url,
                data: payload
            })
                .then(res => {
                    if (res.status) {
                        this.$emit('saved')
                        window.$("#modal-form").modal('hide')
                        _.$toast.success('Data Berhasil Disimpan')
                    } else {
                        _.$toast.warning('Data Gagal Disimpan')
                    }
                    _.resetModel
                    this.$emit('saved', res.data);
                    _.saving = false
                })
                .catch(err => {
                    _.saving = false
                    if (err.response.status === 422) {
                        _.errorValidations = err.response.data.errors
                        _.$refs.observer.setErrors(this.errorValidations);
                        _.$toast.warning('Periksa kembali isian anda')
                    } else if(err.response.status === 404) {
                        _.$toast.error('API belum tersedia')
                    }
                    else {
                        _.resetModel
                        _.$refs.observer.reset();
                        _.$toast.warning('terjadi kesalahan')
                    }
                })
        },
        destroy(item) {
            let _ = this
            this.$swal.fire({
                title: 'Hapus Data Ini?',
                text: "Anda mungkin tidak akan mengembalikannya lagi!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#44A8BD',
                cancelButtonColor: '#D95E6A',
                confirmButtonText: 'Ya, Hapus!',
                cancelButtonText: 'Batal'
            }).then((result) => {
                if (result.value) {
                    _.axios.delete('/material-units/' + item.id)
                        .then(res => {
                            if (res.status) {
                                this.$emit('deleted')
                                _.$toast.success('Data Berhasil dihapus')
                            } else {
                                _.$toast.error('Oops terjadi kesalahan')
                            }
                        })
                        .catch(err => {
                            console.log(err.response)
                            _.$toast.error('Oops terjadi kesalahan')
                        })
                }
            })
        }
    }
}
</script>
